import { useTranslate } from '@dreryk/react-common';
import { FormLabel, StyledFlex } from '@dreryk/react-components';

import type { Field } from '../types';
import { translationKeys } from '../translations';

import { StyledFieldset, StyledFieldsetRadioGroup, StyledFieldsetRadioLabel } from './FieldSelector.styled';

const FIELDS: Array<{ value: Field; labelKey: string }> = [
   { value: 'INTERVIEW', labelKey: translationKeys.panel.fieldInterview },
   { value: 'EXAMINATION', labelKey: translationKeys.panel.fieldExamination },
   { value: 'RECOMMENDATIONS', labelKey: translationKeys.panel.fieldRecommendations },
];

type FieldSelectorProps = {
   value: Field;
   disabled: boolean;
   onChange: (field: Field) => void;
};

export const FieldSelector = (props: FieldSelectorProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledFlex gap={8} direction={'column'}>
         <FormLabel testId={'fieldsetLabel'} label={translationKeys.fieldSelector.legend} />
         <StyledFieldset disabled={props.disabled}>
            <StyledFieldsetRadioGroup role={'radiogroup'}>
               {FIELDS.map(({ value, labelKey }) => (
                  <StyledFieldsetRadioLabel key={value}>
                     <input
                        type={'radio'}
                        name={'transcription-field'}
                        value={value}
                        checked={props.value === value}
                        onChange={() => props.onChange(value)}
                        disabled={props.disabled}
                     />
                     {translate(labelKey)}
                  </StyledFieldsetRadioLabel>
               ))}
            </StyledFieldsetRadioGroup>
         </StyledFieldset>
      </StyledFlex>
   );
};
